import { CheckCircleFilled } from "@ant-design/icons";
import {
  Elements,
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Button, Col, Divider, Grid, Input, Row, Typography } from "antd";
import localforage from "localforage";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { redirect, useLoaderData, useNavigate } from "react-router-dom";
import BEVZsvg from "../../assets/v2/bevzTextLogo.svg";
import configs from "../../components/configs";
import Footer from "../../components/v2/Footer/Footer";
import { pricing2025 as plans } from "../../constants/pricingTier";
import {
  ACTIONTYPES,
  useStoreDispatch,
} from "../../context/CreateStoreContext";
import style from "./PaymentV2.module.css";

const { Title, Text, Paragraph } = Typography;
const { useBreakpoint } = Grid;

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUB_KEY);

export async function loader() {
  try {
    const store = await localforage.getItem("storeV2");

    if (!store?.stripeClient?.clientSecret) {
      return redirect("/");
    }

    return store;
  } catch (err) {
    console.log(err);
    return redirect("/");
  }
}

const PaymentV2 = () => {
  const navigate = useNavigate();
  const dispatch = useStoreDispatch();
  const {
    plan: selectedPlan,
    stripeClient,
    account,
    selectedStore,
    parentStore,
  } = useLoaderData();
  const [currentPlan, setCurrentPlan] = useState(null);
  const screen = useBreakpoint();

  const formatPrice = () => parseFloat(currentPlan?.price).toFixed(2);

  useEffect(() => {
    const selected = selectedPlan || selectedStore?.stripeSubscription?.plan;

    if (selected && plans[selected]) {
      setCurrentPlan(plans[selected]);
    } else {
      setCurrentPlan(null);
    }
  }, [selectedStore, selectedPlan]);

  useEffect(() => {
    if (!stripeClient?.clientSecret) {
      navigate("/");
    }
  }, []);

  return (
    <>
      <div className={style.PaymentV2}>
        <Row align="middle" className={style.LogoContainer}>
          <Col
            xs={0}
            sm={0}
            md={0}
            lg={{ span: 20, offset: 2 }}
            xl={{ span: 14, offset: 5 }}
          >
            <img src={BEVZsvg} alt="Bevz." height="31.83px" />
          </Col>
        </Row>
        <Row
          style={{ paddingBottom: "6.25rem" }}
          className={style.PaymentDetails}
        >
          <Col
            xs={24}
            lg={{ span: 20, offset: 2 }}
            xl={{ span: 14, offset: 5 }}
          >
            <Row>
              <Col
                xs={{ span: 22, offset: 1 }}
                lg={{ span: 11, offset: 0 }}
                xl={{ span: 11, offset: 0 }}
              >
                <div className={style.plan_container}>
                  <div className={style.Tags}>Your selected Plan</div>

                  <Row align="middle" justify="space-between">
                    <Col xs={24} md={12} lg={24}>
                      <Title
                        style={{
                          color: "white",
                          margin: 0,
                          fontSize: screen.xs ? "24px" : "38px",
                        }}
                      >
                        {currentPlan?.label} Plan
                      </Title>
                    </Col>
                    <Col xs={24} md={12} lg={24} className={style.Price}>
                      <Text
                        style={{
                          fontWeight: "300",
                          fontSize: screen.xs ? "20px" : "24px",
                          color: "white",
                        }}
                      >
                        ${currentPlan?.price} per month
                      </Text>
                    </Col>
                  </Row>

                  <div
                    className={style.Packages}
                    style={{ marginBottom: "30px", marginTop: "30px" }}
                  >
                    {currentPlan?.value === plans.GROWTH.value ? (
                      <GrowthPlanPackage />
                    ) : (
                      <BasicPlanPackage />
                    )}
                  </div>
                  <div className={style.Delivery}>
                    Bevz tablet will arrive{" "}
                    <span style={{ fontWeight: "bold" }}>within 1 week</span> of
                    account creation. Packages will be delivered by FedEx.
                  </div>

                  <Divider className={style.Divider} />

                  <div
                    style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}
                  >
                    <div style={{ fontSize: "16px" }}>Monthly Total</div>
                    <div style={{ fontSize: "16px", textAlign: "end" }}>
                      ${formatPrice()}
                    </div>
                    <div style={{ fontSize: "18px", fontWeight: "500" }}>
                      Total due today
                    </div>
                    <div
                      style={{
                        fontSize: "18px",
                        fontWeight: "500",
                        textAlign: "end",
                      }}
                    >
                      $0.00
                    </div>
                  </div>
                </div>
              </Col>
              <Col
                xs={{ span: 22, offset: 1 }}
                md={{ span: 12, offset: 6 }}
                lg={{ span: 11, offset: 2 }}
                xl={{ span: 11, offset: 2 }}
                className={style.Stripe}
              >
                <Title level={screen.xs ? 3 : 2} className={style.Header}>
                  Checkout
                </Title>
                <Input
                  prefix="Email"
                  size="large"
                  style={{ marginBottom: "30px", backgroundColor: "#EDF0F8" }}
                  defaultValue={
                    stripeClient?.fromAdmin
                      ? parentStore?.username
                      : account?.emailAddress
                  }
                  disabled
                  placeholder="owner@email.com"
                />
                <Paragraph style={{ fontSize: "16px", marginBottom: "12px" }}>
                  <Text strong>Payment method</Text>
                </Paragraph>

                <Elements
                  stripe={stripePromise}
                  options={{
                    clientSecret:
                      stripeClient?.clientSecret ||
                      "seti_1QS8KKCBc3T9wIygNeMKRSpQ_secret_RKnwUWOml4NIU2AufK3n1IrE90EOUTI",
                  }}
                >
                  <SubscriptionForm
                    fromAdmin={Boolean(stripeClient?.fromAdmin)}
                  />
                </Elements>

                <div className={style.Footer}>
                  You will be charged ${formatPrice()} per month starting{" "}
                  {moment().add(1, "month").format("MMMM D, YYYY")}. You have
                  the option to decide before the period ends.
                  <br />
                  <br />
                  You also agree to the{" "}
                  <a
                    href="https://www.bevz.com/terms-of-service"
                    target="_blank"
                    className={style.link}
                  >
                    Link Terms
                  </a>{" "}
                  and{" "}
                  <a
                    href="https://www.bevz.com/privacy-policy"
                    target="_blank"
                    className={style.link}
                  >
                    Privacy Policy.
                  </a>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <Footer />
    </>
  );
};

const SubscriptionForm = ({ fromAdmin = false }) => {
  const stripe = useStripe();
  const dispatch = useStoreDispatch();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (!stripe || !elements) return;

    const { error } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: configs.url.thankYouPage + "?admin=" + fromAdmin,
      },
    });
    setLoading(false);
    if (error) {
      console.log(error);
      setMessage(error?.message || "A processing error occurred.");
    } else {
      dispatch({ type: ACTIONTYPES.STRIPECLIENT, data: null });
    }
  };

  const paymentElementOptions = {
    layout: "tabs",
  };

  return (
    <>
      <form id="payment-form">
        <PaymentElement id="payment-element" options={paymentElementOptions} />

        <div className={style.payment_button_container}>
          {/* Show any error or success messages */}
          {message && (
            <div id="payment-message" style={{ color: "#df1b41" }}>
              {message}
            </div>
          )}
          <Button
            disabled={loading || !stripe || !elements}
            id="submit"
            className={style.brand_button}
            loading={loading}
            size="large"
            iconPosition="end"
            onClick={handleSubmit}
          >
            Start Subscription
          </Button>
        </div>
      </form>
    </>
  );
};

const BulletContainer = ({ iconColor = "#34C759", children }) => (
  <div
    style={{
      fontSize: "18px",
      fontWeight: "200",
      color: "white",
      marginBottom: "10px",
    }}
  >
    <CheckCircleFilled style={{ color: iconColor, paddingRight: "10px" }} />{" "}
    {children}
  </div>
);

const BasicPlanPackage = () => (
  <>
    {[
      "Bevz iPad & Software",
      "Menu management & optimization",
      "Product Catalog",
      "Delivery Services",
    ].map((label) => (
      <BulletContainer key={label}>{label}</BulletContainer>
    ))}
  </>
);

const GrowthPlanPackage = () => (
  <>
    <BulletContainer iconColor="#E99E25">
      All features in Basic plan included
    </BulletContainer>
    {["Bevz Reach", "Shop.Bevz", "Bevz Reporting+"].map((label) => (
      <BulletContainer key={label}>{label}</BulletContainer>
    ))}
  </>
);

export default PaymentV2;
